import { useRecoilValue } from "recoil";
import tokenState from "../states/TokenState";

export function useToken() {
  const token = useRecoilValue(tokenState);
  return token;
}
